<form *ngIf="profileForm" [formGroup]="profileForm" (ngSubmit)="saveChanges()">
  <div class="modal-header">
    <h5 class="modal-title">Edit Profile</h5>
    <button type="button" class="btn-close" (click)="modalRef.close()"></button>
  </div>

  <div class="modal-body">
    <!-- Name -->
    <div class="form-outline mb-4">
      <label class="form-label">Name</label>
      <input class="form-control" formControlName="name" />
    </div>
<div class="form-outline mb-4">
      <label class="form-label">Designation</label>
      <input class="form-control" formControlName="designation" />
    </div>
    <!-- Phone -->
<!-- Phone -->
<!-- Phone -->
<div class="form-outline mb-4">
  <label class="form-label d-block">Phone</label>
  <div class="phone-wrapper">
    <select class="form-select" formControlName="country_code">
      <option *ngFor="let country of MobileCountries" [value]="country.dialCode">
        +{{ country.dialCode }} ({{ country.name }})
      </option>
    </select>
    <input class="form-control" formControlName="phone" placeholder="Enter phone number" />
  </div>
</div>




    <!-- About Me -->
    <div class="form-outline mb-4">
      <label class="form-label">About Me</label>
      <textarea
        class="form-control"
        formControlName="about_me"
        maxlength="2500"
        rows="4"
        (input)="onAboutMeChange()"
        placeholder="Tell us about yourself (max 2500 characters)"
      ></textarea>
      <small class="text-muted d-block text-end">
        {{ aboutMeLength }}/2500 characters
      </small>
    </div>

    <!-- Nationality -->
    <div class="form-outline mb-4"  *ngIf="!IsRecruiter">
      <label class="form-label">Nationality</label>
      <select class="form-select" formControlName="country_id">
        <option value="" disabled>Select nationality</option>
        <option *ngFor="let country of countries" [value]="country.country_id">
          {{ country.value }}
        </option>
      </select>
    </div>

    <!-- Education -->
    <div class="form-outline mb-4" *ngIf="!IsRecruiter">
      <label class="form-label">Education</label>
      <select class="form-select" formControlName="education_level_id">
        <option value="" disabled>Select education</option>
        <option *ngFor="let edu of educationLevels" [value]="edu.education_level_id">
          {{ edu.value }}
        </option>
      </select>
    </div>

    <!-- Experience -->
    <div class="form-outline mb-4" *ngIf="!IsRecruiter">
      <label class="form-label">Experience</label>
      <select class="form-select" formControlName="experience_years_id">
        <option value="" disabled>Select experience</option>
        <option *ngFor="let exp of experienceYears" [value]="exp.experience_years_id">
          {{ exp.value }}
        </option>
      </select>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.close()">Cancel</button>
    <button type="submit" class="btn btn-primary" [disabled]="profileForm.invalid">Save Changes</button>
  </div>
</form>
